<template>
    <AboutHead :headline-blue="$t('nav_faq')" :headline="$t('faq_section_head')" />

    <div class="mx-auto container z-10 pb-4 px-2">
        <div id="faqs">
            <div v-for="(faqs, category) in groupedFaqs" :key="category" class="mb-12">
                <!-- Kategorie-Headline -->
                <strong data-aos="fade-right">
                    <h3 class="px-4 pt-10">
                        {{ $t(category) }}
                    </h3>
                </strong>

                <!-- FAQs der Kategorie -->
                <div class="px-2 pb-2">
                    <div v-for="faq in faqs" :key="faq.id" data-aos="fade-up">
                        <Accordeon :title="faq.question" :content="faq.answer" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CookieReset from '../components/CookieReset.vue';
import Accordeon from '../components/miscellaneous/Accordeon.vue';
import { useCcm19Global } from '../useCcm19Global';
import { fetchData } from '../fetchData.js';

export default {
    components: { Accordeon, CookieReset },

    setup() {
        const { onReady, youtube } = useCcm19Global();
        onReady(() => {});

        return { youtube };
    },
    data() {
        return {
            activeTab: 0,

            activeVideoTab: 0,
            activeFaq: null,
            faqs_app: [],
            tabsDE: [
                {
                    title: 'Website',
                    copy: 'howto_website_1_leading',
                    videos: [
                        { title: 'howto_website_11_company', id: 'a9c83a7d-a8f5-4fd8-a240-19e4b699c3e5' },
                        { title: 'howto_website_12_products', id: '9c926135-d47c-42a3-8bfd-6ec20664978f' },
                        { title: 'howto_website_13_subscribe', id: 'f45a11fe-6296-4a3e-b197-a5c415b49891' },
                        { title: 'howto_website_14_news', id: '8cc4aab4-97e3-4b46-b18b-66f64193c4a3' }
                    ]
                },
                {
                    title: 'Dashboard',
                    copy: 'howto_dashboard_2_leading',
                    videos: [
                        { title: 'howto_dashboard_21_log_in', id: '63425a3f-fb52-496b-81ad-b98fa6d6e084' },
                        { title: 'howto_dashboard_22_viewing_analyses', id: 'd45ea6e6-dc39-4d21-ba41-d655829bbc71' },
                        { title: 'howto_dashboard_23_video_analyses', id: '2ac75eb8-4b29-4bc2-b7b5-69f115719c0c' },
                        { title: 'howto_dashboard_24_profile_settings', id: '3941f808-b348-461a-b420-6f8231b862e4' },
                        { title: 'howto_dashboard_25_payments_invoices', id: 'c62458b9-b3c9-4833-9018-513f6acb2732' },
                        { title: 'howto_dashboard_26_manage_subscriptions', id: '6012124b-d95f-423a-a2c3-4b36682299dc' }
                    ]
                },
                {
                    title: 'Charts',
                    copy: 'howto_charts_3_leading',
                    videos: [
                        { title: 'howto_charts_31_updates', id: '626d6e77-dc55-4964-834f-2a6dc002fcda' },
                        { title: 'howto_charts_32_our_charts', id: 'e68d055f-4a28-4fc3-b364-46ddd29abb84' },
                        { title: 'howto_charts_33_scenarios', id: '68fb9a97-2365-44af-85da-950a793e41dd' }
                    ]
                },
                {
                    title: 'Trading',
                    copy: 'howto_trading_4_leading',
                    videos: [
                        { title: 'howto_trading_41_future_market', id: '47862148-fc4b-46b2-a3bf-e935b5f5d3a9' },
                        { title: 'howto_trading_42_parameters', id: '7bb8d619-5d1f-4feb-b68d-81cf4f09e54a' },
                        { title: 'howto_trading_43_position_sizes', id: 'dd4e8bdc-a99d-4df4-b169-3d9646b78c45' }
                    ]
                }
            ],
            tabsGLO: [
                {
                    title: 'Dashboard',
                    copy: 'howto_dashboard_2_leading',
                    videos: [
                        { number: 1, title: 'plain_introduction', id: '204e9dbe-2aad-43d2-ad3b-31d5ec7047fb' },
                        { number: 2, title: 'nav_dashboard', id: '8f452bd0-bbc3-4f32-aace-84a178f16436' },
                        { number: 3, title: 'nav_analysis', id: '5c0b8f0a-dead-45e7-8e7f-6bee7cc1c51d' },
                        { number: 4, title: 'nav_portfolio', id: '889fc027-35d1-4776-86f7-690b23265ac4' },
                        { number: 5, title: 'nav_our_charts', id: '6fcfce96-724a-4ded-93bd-d05ec6dee1fa' }
                    ]
                }
            ],
            faqs: [
                'faqs_lost_login_access',
                'faqs_book_additional_markets',
                'faqs_extend_monthly_subscription',
                'faqs_add_video_analysis_later',
                'faqs_switch_current_subscription_into_another_subscription',
                'faqs_subscription_renew_automatically',
                'faqs_change_registered_email',
                'faqs_not_receiving_email_updates',
                'faqs_supported_payment_methods',
                'faqs_change_my_payment_method',
                'faqs_find_invoices',
                'faqs_cancel_subscription',
                'faqs_register_newsletter',
                'faqs_available_discounts',
                'faqs_general_analyses',
                'faqs_general_results',
                'faqs_general_affiliate'
            ],
            faqs_new_dashboard: [
                { phrase_key: 'faqs_dashboard_subscriptions' },
                { phrase_key: 'faqs_dashboard_performance_portfolio' },
                { phrase_key: 'faqs_dashboard_find_open_markets', link: this.$asset('/hkcm/images/faqs/faqs_new_dashboard_market.png', 'public') },
                { phrase_key: 'faqs_dashboard_mail_management' }
            ],
            faqs_tradingSystem: [
                {
                    phrase_key: 'faqs_trading_terms',
                    img1: this.$asset('/hkcm/images/faqs/faqs_tradingSystem_1.png', 'public'),
                    img2: this.$asset('/hkcm/images/faqs/faqs_tradingSystem_2.png', 'public'),
                    img3: this.$asset('/hkcm/images/faqs/faqs_tradingSystem_3.png', 'public')
                },
                { phrase_key: 'faqs_trading_changes_optimized_strategy' },
                { phrase_key: 'faqs_trading_how_we_trade_fifo' },
                { phrase_key: 'faqs_trading_customer_to_dos' },
                { phrase_key: 'faqs_trading_entries_stops_tps' },
                { phrase_key: 'faqs_trading_how_get_info' },
                { phrase_key: 'faqs_trading_position_sizing' },
                { phrase_key: 'faqs_trading_open_trade' },
                { phrase_key: 'faqs_trading_depot_split_example' },
                { phrase_key: 'faqs_trading_close_half_trade' },
                { phrase_key: 'faqs_trading_slippage_gap_risk' },
                { phrase_key: 'faqs_trading_can_deviate' },
                { phrase_key: 'faqs_trading_tax_legal' },
                { phrase_key: 'faqs_trading_performance_tracking' },
                { phrase_key: 'faqs_trading_high_low_volatility' }
            ],
            faqsData: []
        };
    },
    computed: {
        currentLanguage() {
            return window.meta.region_configuration.region;
        },
        tabs() {
            return this.currentLanguage === 'de' ? this.tabsDE : this.tabsGLO;
        },
        groupedFaqs() {
            return this.faqsData.reduce((groups, faq) => {
                if (!groups[faq.category]) {
                    groups[faq.category] = [];
                }

                groups[faq.category].push(faq);

                return groups;
            }, {});
        }
    },
    watch: {
        currentLanguage: {
            immediate: true,
            handler(newLang) {
                this.faqs_app = this.getFaqsApp(newLang);
            }
        }
    },
    mounted() {
        this.faqs_app = this.getFaqsApp(this.currentLanguage);
        this.getFaqs();
    },
    methods: {
        getFaqsApp(language) {
            return [
                { phrase_key: 'faqs_app_missing_content' },
                { phrase_key: 'faqs_app_subscribe' },
                { phrase_key: 'faqs_app_unsubscribe' },
                { phrase_key: 'faqs_app_contact' },
                { phrase_key: 'faqs_app_invoice' },
                { phrase_key: 'faqs_app_new_package' },
                { phrase_key: 'faqs_app_tragetzone_vs_tradingarea' },
                { phrase_key: 'faqs_app_performance_portfolio' },
                {
                    phrase_key: 'faqs_app_target_zones',
                    link: language === 'de' ? this.$asset('/hkcm/images/faqs/faqs_app_zz.png', 'public') : this.$asset('/hkcm/images/faqs/faqs_app_pt.png', 'public')
                },
                { phrase_key: 'faqs_app_view_analysis' }
            ];
        },
        scrollToVideo() {
            if (window.innerWidth < 1024) {
                this.$nextTick(() => {
                    const el = this.$refs.video;

                    if (el) {
                        const header = document.querySelector('header');
                        const headerHeight = header ? header.offsetHeight : 0;
                        window.scrollTo({ top: el.offsetTop - headerHeight, behavior: 'smooth' });
                    }
                });
            }
        },
        async getFaqs() {
            const response = await fetchData('/api/v1/howToFaqs');

            this.faqsData = response?.result?.data ?? [];
        }
    }
};
</script>
